export interface IPriceRelevance {
  /** Описание в попапе **/
  description: string;
  /** Состояние актуальности, строка **/
  label: string;
  /** Заголовок попапа **/
  title: string;
  /** Статус актуальности **/
  type: EType;
}
export enum EType {
  /** Цены актуальны **/
  'Actual' = 'actual',
  /** Цены устарели **/
  'Warning' = 'warning',
}
